// Géométrie locale en mètres pour le moteur de détection. Les distances en jeu (quelques mètres à quelques centaines
// de mètres) permettent une projection équirectangulaire autour d'une origine : erreur négligeable devant la
// précision GPS, calcul simple et explicable.

export interface LatLng {
  lat: number
  lng: number
}

export interface LocalPoint {
  /** Est, en mètres. */
  x: number
  /** Nord, en mètres. */
  y: number
}

const earthRadiusMeters = 6_371_000
const toRadians = (degrees: number) => (degrees * Math.PI) / 180
const toDegrees = (radians: number) => (radians * 180) / Math.PI

export function toLocal(origin: LatLng, point: LatLng): LocalPoint {
  const cosLat = Math.cos(toRadians((origin.lat + point.lat) / 2))
  return {
    x: toRadians(point.lng - origin.lng) * cosLat * earthRadiusMeters,
    y: toRadians(point.lat - origin.lat) * earthRadiusMeters,
  }
}

export function fromLocal(origin: LatLng, point: LocalPoint): LatLng {
  const lat = origin.lat + toDegrees(point.y / earthRadiusMeters)
  const cosLat = Math.cos(toRadians((origin.lat + lat) / 2))
  return { lat, lng: origin.lng + toDegrees(point.x / (earthRadiusMeters * cosLat)) }
}

export function metersBetween(a: LatLng, b: LatLng): number {
  const { x, y } = toLocal(a, b)
  return Math.hypot(x, y)
}

export type Ring = 'CAPTURE' | 'WORK' | 'BAND' | 'OUTSIDE'

export interface Radii {
  captureRadiusM: number
  workRadiusM: number
  exitDistanceM: number
}

/** Anneau occupé à une distance donnée du drapeau. La bande sépare la zone de travail de la distance de sortie. */
export function ringAt(distanceM: number, radii: Radii): Ring {
  if (distanceM <= radii.captureRadiusM) return 'CAPTURE'
  if (distanceM <= radii.workRadiusM) return 'WORK'
  if (distanceM <= radii.exitDistanceM) return 'BAND'
  return 'OUTSIDE'
}
